import { render, staticRenderFns } from "./FangYuanGL.vue?vue&type=template&id=08f6cb37&scoped=true"
import script from "./FangYuanGL.vue?vue&type=script&lang=js"
export * from "./FangYuanGL.vue?vue&type=script&lang=js"
import style0 from "./FangYuanGL.vue?vue&type=style&index=0&id=08f6cb37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6cb37",
  null
  
)

export default component.exports